import React, { useState } from 'react';
import styled from 'styled-components';
import BarLineGraph from 'sub_components/Common/BarLineGraph';
import { ToggleButtonNew } from 'styled_components/Common/ToggleButtonNew';

const ColoGraphStyle = styled.div`
	width: 100%;
	height: 100%;
	//background-color: ${props => props.theme.white};
	display: flex;
	justify-content: center;
	align-items: center;
	background: ${props => props.theme.Cool_Gray_Light_3};

	.graph-container {
		height: 100%;
		position: relative;
		.graph-resolution-picker {
			position: absolute;
			right: 0;
			top: -20px;
		}
	}
	.highcharts-tooltip-container {
		z-index: 3000 !important;
	}
	.highcharts-tooltip-custom {
		width: 100px;
		height: 200px;
		border-radius: 20px;

		.highcharts-tooltip {
			stroke: transparent;
			fill: transparent;
		}
		span {
			top: 0px !important;
			left: 0px !important;
		}
	}

	.legend {
		display: flex;
		width: 100px;
		height: 30px;
		position: absolute;
		top: 0px;
		left: 20px;
		.legend-item {
			display: flex;
			align-items: center;
			flex-direction: column;
			width: 50px;
			.mark {
				width: 30px;
				height: 5px;
				border-radius: 20px;
				background-color: #4ac489;
				&.dark {
					background-color: #00ad5c;
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.legend {
			width: 100px;
			height: 30px;

			left: 20px;
			.legend-item {
				width: 50px;

				.mark {
					width: 30px;
					height: 5px;
				}
			}
		}
		.graph-container {
			.graph-resolution-picker {
				top: -24px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.legend {
			width: 100px;
			height: 30px;
			left: 40px;
			.legend-item {
				width: 50px;

				.mark {
					width: 30px;
					height: 5px;
				}
			}
		}
		.graph-container {
			.graph-resolution-picker {
				top: -32px;
			}
		}
	}
`;

export const ColoGraph = ({ id, cypressId, breakpoint, orgId }) => {
	const [resolution, setResolution] = useState('hourly');

	return (
		<ColoGraphStyle id={id} data-cy={cypressId} className='power-trends'>
			<div className='graph-container'>
				<div className='graph-resolution-picker'>
					<ToggleButtonNew
						module='colocation'
						id='toggle-slider-colo'
						onClick={setResolution}
						options={['hourly', 'daily', 'monthly']}
						selected={resolution}
					/>
				</div>
				<BarLineGraph resolution={resolution} breakpoint={breakpoint} orgId={orgId} />
				<div className='legend'>
					<div className='legend-item'>
						<div className='label body10'>Side A</div>
						<div className='mark'></div>
					</div>
					<div className='legend-item'>
						<div className='label body10'>Side B</div>
						<div className='mark dark'></div>
					</div>
				</div>
			</div>
		</ColoGraphStyle>
	);
};
